<template>
  <div
    v-if="visible"
    class="products-sort"
    role="region"
    :aria-label="$t('product_list.header.sortBy')"
  >
    <label class="products-sort__label">
      {{ $t('product_list.header.sortBy') }}
    </label>
    <select-vue
      class="products-sort__select select--formless"
      v-model="value"
      name="sort"
      :options="options"
      :initial-value="value"
    />
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import productListStore, {ProductListStore} from '../../../bps/stores/product/ProductListStore';
  import productListService, {ProductsListService} from '../../../bps/services/productsList/ProductsListService';
  import selectVue from '../../../bps/components/select/select.vue';
  import type SortOption from '../../types/SortOption';
  import {usePlaceholder} from '../../utilities/vueMixins/placeholderMixin/placeholder';

  @Options({
    name: 'products-sort',
    components: {
      selectVue
    }
  })
  export default class ProductsSort extends Vue {
    @Prop()
    name: string;

    productListStore: ProductListStore = productListStore;

    mounted() {
      usePlaceholder('products-sort');
    }

    get options(): SortOption[] {
      return this.productListStore.sortingData || [];
    }

    get value(): string {
      if (!this.options.length) {
        return '';
      }

      const selectedOptions: SortOption[] = this.options.filter(o => o.selected);
      if (selectedOptions.length) {
        return selectedOptions[0].value;
      }

      return this.options[0].value;
    }

    get visible(): boolean {
      return this.options.length > 0 && this.productListStore.elementsList.elements.length > 0;
    }

    set value(data) {
      if (this.value != data) {
        const param = {};
        param[ProductsListService.sortParameterName] = [data];
        param[ProductsListService.pageParameterName] = ['0'];
        productListService.changeParameters(param);
      }
    }
  }
</script>
